import { useState } from "react";
import { useTranslation } from "react-i18next";
import { CalendarDays, Mail, UsersRound } from "lucide-react";
import RecordsPage from "../records/RecordsPage";

const sections = [
  { key: "visits", label: "Visitors", icon: UsersRound },
  { key: "correspondence", label: "Correspondence", icon: Mail },
  { key: "interviews", label: "Interviews", icon: CalendarDays },
] as const;

export default function MyActivityPage() {
  const { t } = useTranslation();
  const [section, setSection] = useState<(typeof sections)[number]["key"]>(
    "visits",
  );

  return (
    <div className="my-activity-page">
      <div className="activity-switch" role="tablist" aria-label={t("My activity sections")}>
        {sections.map((item) => {
          const Icon = item.icon;
          const selected = section === item.key;
          return (
            <button
              key={item.key}
              type="button"
              role="tab"
              aria-selected={selected}
              className={selected ? "active" : ""}
              onClick={() => setSection(item.key)}
            >
              <Icon size={17} />
              {t(item.label)}
            </button>
          );
        })}
      </div>
      <RecordsPage key={section} featureKey={section} />
    </div>
  );
}
